export default {
  testimonialtwo: {
    subtitle: "آراء العملاء",

    title1: "ماذا تقول",
    title2: "الشركات",

    desc:
      "تثق المطاعم والموردون في MAHAL لتبسيط عمليات التوريد وضمان الشفافية وبناء شراكات طويلة الأمد.",

    review:
      "جعلت MAHAL عملية التوريد أسرع وأكثر شفافية. شبكة الموردين وتتبع الطلبات موثوقة للغاية.",

    cta: "انضم إلى MAHAL اليوم",

    users: [
      { name: "بارثولوميو", role: "صاحب مطعم" },
      { name: "صوفي", role: "مدير المشتريات" },
      { name: "إسرات جهان", role: "شريك أعمال" },
    ],
  },
};